import { auth } from "apis";

export const getAllUserBasedOnStatus = async (page, limit, status, search,gender) => {
    const res = await auth({
      method: "GET",
      url: `/verification/requestes?page=${page}&limit=${limit}&status=${status}&search=${search}&gender=${gender}`,
    });
    return res
}
  
export const updateUserBasedOnStatus = async (id, data) => {
    const res = await auth({
      method: "PUT",
      url: `/verification/update/${id}`,
      data
    });
    return res
  }